import ApiService from '@/services/core/api.service'

const PendingService = {
  async get (query = '') {
    return ApiService.get(`user/payment-requests?${query}`)
  },

  async show (id) {
    return ApiService.get(`user/payment-requests/${id}`)
  },

  async post (payload) {
    return ApiService.post('user/payment-requests', payload)
  },

  async put (payload) {
    return ApiService.put(`user/payment-requests/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/payment-requests/${payload.id}`)
  }
}

export default PendingService
